import type { ReactNode } from 'react';
import styles from './styles.module.css';

interface StepListProps {
  children: ReactNode;
  className?: string;
}

export function StepList({ children, className = '', ...props }: StepListProps): ReactNode {
  return (
    <ul className={`${styles['step-list']} ${className}`} {...props}>
      {children}
    </ul>
  );
}
